import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=34b880a2"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=34b880a2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports